<template lang="pug">
div 
  Loader(
    :loading="loading",
    :message="loaderMessage",
    :retry="loadeRetry",
    @load-retry="loadRetry"
  )

  .product-listing
    .product-info.is-flex-desktop.columns
      .column.is-12.has-text-left(v-if="zones.length")
        .box.map-details
          div(style="padding: 1rem")
            h2.title.is-uppercase FIBRE CONNECTIVITY
            p.has-text-weight-normal View and compare your connectivity options for
            p(style="margin-bottom: 10px")
              b {{ buildAddressWithName }}
            a(
              @click="$router.push({ name: 'home' })",
              style="color: #000; text-decoration: underline"
            ) Change address
          img.product-user-map(
            @error="mapLoadError()",
            :src="`https://maps.googleapis.com/maps/api/staticmap?zoom=15&size=640x360&maptype=roadmap&markers=${builtAddress.replace(/,\\s+/g, ',').replace(/\\s+/g, '+')}${mapPathString}&key=${mapsKey}`"
          )
        .product-options.box.has-text-left(
          v-for="(zone, k) of zones",
          :key="k"
        )
          h1.title {{ zone.provider_name }}

          .packages.columns(
            v-for="(promoCode, index) of zone.promoCodes",
            :key="index",
            style="flex-wrap: wrap"
          )
            .column.is-4.is-flex(
              v-for="(prod, id) of promoCode.products",
              :key="id"
            )
              .box.is-flex.product-box(style="flex-direction: column"
                v-for="(pr, id) of prod.main_product",
                :key="id"
                )
                  div(v-if="!pr.showDetails")
                    h2.title(style="margin-bottom: 0") {{ pr.name }}
                    p.has-text-weight-normal.has-text-primary(
                      style="margin-bottom: 1rem"
                    ) {{ pr.monthly == '0.00' ? 'FREE' : 'R ' + pr.monthly }}

                    div(style="margin-top: 1rem; margin-bottom: 1rem; flex: 1")
                      a.info-link(
                        @click.prevent="pr.showDetails = true; $forceUpdate()"
                      ) Full product details

                  div(v-else)
                    a.has-text-black.has-text-weigh
                    .product-details-topt-normal(
                        @click.prevent="pr.showDetails = false; $forceUpdate()"
                      )
                        b X
                        span.additional-text CLOSE
                    h1.title FULL PRODUCT DETAILS
                    ul.product-details-perks.has-text-weight-normal.has-text-left(
                      v-if="pr.details"
                    )
                      li.product-details-perk(
                        v-for="pD in productDetails(pr.details)"
                      )
                        fa-icon(icon="check-circle")
                        | {{ pD }}
                    p.has-text-weight-normal.has-text-left(v-else) No details available for this product
                  .product-button-wrap
                    button.button.is-primary.is-fullwidth.product-details-button(
                      @click.prevent="setProduct(pr, promoCode.code, `${zone.provider_name}=${index}`)"
                    ) GET THIS

    .modal(v-bind:class="{ 'is-active': showModal }")
      .modal-background
      .modal-card
        header.modal-card-head
          p.modal-card-title PLEASE CONFIRM YOUR ADDRESS BELOW
          button.delete(aria-label="close", @click.prevent="showModal = false")
        section.modal-card-body
          .add-address
            .columns(style="margin: 0", v-if="productType != 'data-only'")
              .column.is-4
                .input-group
                  .control.radio-control
                    label.radio
                      input(
                        type="radio",
                        name="installType",
                        value="new",
                        @click="setInstallType('new')",
                        :checked="installType === 'new'",
                        style="margin-right: 5px"
                      )
                      span(style="font-size: 14px")
                        | New Installation
              .column.is-4
                .input-group
                  .control.radio-control
                    label.radio
                      input(
                        type="radio",
                        name="installType",
                        value="existing",
                        @click="setInstallType('existing')",
                        :checked="installType === 'existing'",
                        style="margin-right: 5px"
                      )
                      span(style="font-size: 14px")
                        | Move from another ISP/ reactivate a dormant installation
              .column.is-4
                .input-group
                  .control.radio-control
                    label.radio
                      input(
                        type="radio",
                        name="installType",
                        value="upgrade",
                        @click="setInstallType('upgrade')",
                        :checked="installType === 'upgrade'",
                        style="margin-right: 5px"
                      )
                      span.radio-checkmark
                        | Upgrade/ Downgrade
            .columns(style="margin: 0")
              .column.is-6
                label
                  input(
                    type="radio",
                    name="type-of-address",
                    :value="'streetAddress'",
                    v-model="typeOfAddress"
                  )
                  span(style="font-size: 14px") &nbsp; Freestanding House/Dwelling
              .column.is-6
                label
                  input(
                    type="radio",
                    name="type-of-address",
                    :value="'unit'",
                    v-model="typeOfAddress"
                  )
                  span(style="font-size: 14px") &nbsp; Building/Complex
            b(v-show="typeOfAddress == 'unit'") Unit
            CustomInput(
              type="text",
              v-model="unitNumber",
              required,
              placeholder="Enter your unit / flat number",
              v-show="typeOfAddress == 'unit'"
            )
            p.help.is-danger(
              v-if="unitNumberError",
              v-show="typeOfAddress == 'unit'"
            ) {{ unitNumberError }}

            CustomInput(
              type="text",
              v-model="buildingName",
              placeholder="Enter building name (optional)",
              v-show="typeOfAddress == 'unit'"
            )
            CustomInput(
              type="text",
              disabled,
              v-model="buildAddressWithName",
              style="margin-top: 0.75rem"
            )

            button.button.is-primary.product-details-button(
              :disabled="!typeOfAddress || !unitNumber && typeOfAddress == 'unit'",
              @click.prevent="submitAddress"
            ) {{installType === "upgrade" ? "UPGRADE/DOWNGRADE" : "PROCEED TO SIGNUP"}}

            button.button.is-secondary.product-details-button(
              @click.prevent="$router.push({ name: 'home' })",
              style="margin-left: 10px"
            ) CHANGE ADDRESS
</template>

<script>
import _ from "lodash";
import Search from "@/components/Search.vue";
import CustomInput from "@/components/CustomInput.vue";
import Loader from "@/components/Loader.vue";

import kmlParser from "../parseKml";

export default {
  name: "ShowAllComponent",
  components: {
    Loader,
    Search,
    CustomInput,
  },
  props: ["address"],
  data() {
    return {
      loading: false,
      loaderMessage: null,
      loadeRetry: false,
      productType: null,

      name: null,
      zones: [],
      newAddress: "",
      fullAddress: null,
      selectedAddress: null,
      showDetails: false,
      addAddress: false,
      showModal: false,
      chosenProduct: null,
      productIds: {},
      zoneCoordsString: null,
      typeOfAddress: null,
      streetNumber: null,
      streetName: null,
      suburb: null,
      postCode: null,
      unitNumber: null,
      buildingName: null,
      streetNumberError: null,
      streetNameError: null,
      suburbError: null,
      postCodeError: null,
      unitNumberError: null,
      position: {
        lat: -33.9099856,
        lng: 18.41292670000007,
      },
      limitData: null,
      unitRegex: /^[a-zA-Z]?\d{1,4}[a-zA-Z]{0,2}$/
    };
  },
  async mounted() {
    this.loading = true;
    if (this.$store.getters.getSpecifiedFullAddress) {
      this.fullAddress = this.$store.getters.getSpecifiedFullAddress;
    }

    if (this.address.trim().indexOf(" ") === -1) {
      const hm = new FormData();
      hm.set("zone", this.address);

      let response = null;
      try {
        response = await this.$http.post(
            `${process.env.VUE_APP_BACKEND_URL}feasibility/lookup_v2`,
            hm);
      } catch (e) {
        this.loading = false;
        this.$router.push({name: "home", params: {error: "Server error, please try again later"}});
        return;
      }

      this.zoneCoordsString = kmlParser.extractCoordFromKml(response.data.kml);

      // build address from response
      const adBreak = response.data.address.split(",");
      this.fullAddress = {
        street_number: null,
        route: adBreak[0].trim(),
        political: adBreak[1].trim(),
        locality: response.data.city,
        administrative_area_level_2: response.data.city,
        administrative_area_level_1: response.data.province,
        country: "ZA",
        postal_code: response.data.postal_code,
      };

      this.name = response.data.name;
      this.updatePromoCodeProducts(response.data);
      this.zones.push(response.data);
      this.setBuiltAddress();
      this.loading = false;
    } else {
      await this.$gmapApiPromiseLazy();
      // eslint-disable-next-line
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: this.address }, async (results, status) => {
        if (status === "OK") {
          console.log("results[0]", results[0]);
          this.position.lat = results[0].geometry.location.lat();
          this.position.lng = results[0].geometry.location.lng();

          // set limit data for new address search
          this.limitData = {
            radius: process.env.VUE_APP_MAPS_LIMIT_RANGE || 5000,
            location: results[0].geometry.location,
          };

          if (!this.fullAddress) {
            console.log("!this.fullAddress");
            const addressArray = {};
            results[0].address_components.forEach((component) => {
              addressArray[component.types[0]] = component.long_name;
              if (component.types[0] === "route" || component.types[0] === "street_name") {
                addressArray["routeShort"] = component.short_name;
              }
            });
            this.fullAddress = addressArray;
          }

          let hm = new FormData();
          hm.set("latitude", this.coordsFromMap.lat || this.position.lat);
          hm.set("longitude", this.coordsFromMap.lng || this.position.lng);

          let response = null;
          try {
            response = await this.$http.post(
                `${process.env.VUE_APP_BACKEND_URL}feasibility/find_v2`,
                hm
            );

            response.data.forEach(item => {
             this.updatePromoCodeProducts(item);
            });
            this.zones = response.data;

            this.setBuiltAddress();

            if (this.addressCode) {
              hm = new FormData();
              hm.set("zone", this.addressCode);

              response = null;
              try {
                response = await this.$http.post(
                    `${process.env.VUE_APP_BACKEND_URL}feasibility/lookup_v2`,
                    hm
                );
                this.zoneCoordsString = kmlParser.extractCoordFromKml(response.data.kml);
              } catch (e) {
                this.loading = false;
                this.$router.push({name: "home"});
                return;
              }
            }
          } catch (e) {
            this.loading = false;
            this.$router.push({name: "home", params: {error: "Server error, please try again later"}});
            return;
          }

          this.loading = false;
        }
      });
    }
  },
  computed: {
    coordsFromMap() {
      return this.$store.getters.getCoordsFromMap;
    },
    mapPathString() {
      return this.zoneCoordsString? `&path=color:blue|fillcolor:blue|weight:2|${this.zoneCoordsString}` : "";
    },
    provinces() {
      return this.$store.getters.getProvinces;
    },
    promoCodeId() {
      return this.$store.getters.getPromoCodeId;
    },
    builtAddress() {
      return this.$store.getters.getBuiltAddress;
    },
    buildAddressWithName() {
      return this.name? this.name + ", " + this.$store.getters.getBuiltAddress : this.$store.getters.getBuiltAddress;
    },
    installType() {
      return this.$store.getters.getInstallType;
    },
    productSection() {
      return (
        this.$store.getters.getProductSection ||
        (this.zones.length ? `${this.zones[0].provider_name}=null` : null)
      );
    },
    selectedProduct() {
      return this.$store.getters.getSelectedProduct;
    },
    codeKey() {
      return this.productSection ? this.productSection.split("=") : null;
    },
    zone() {
      return this.codeKey
        ? _.find(this.zones, { provider_name: this.codeKey[0] })
        : null;
    },
    addresses() {
      return this.zone
        ? _.isArray(this.zone.addresses[0])
          ? this.zone.addresses[0]
          : this.zone.addresses
        : null;
    },
    addressCode() {
      return this.zone ? this.zone.code : null;
    },
    mapsKey() {
      return process.env.VUE_APP_MAPS_API_KEY;
    },
  },
  watch: {
    addAddress(val) {
      if (val) this.selectedAddress = null;
    },
    promoCodeId(val) {
      const description = _.find(this.zone.promoCodes, (o) => {
        return o.code == val;
      }).description.toLowerCase();

      if (description.indexOf("data only") >= 0) {
        this.setInstallType("data-only");
        this.productType = "data-only";
      } else if (description.indexOf("dsl") >= 0) {
        this.setInstallType("new");
        this.productType = "dsl";
      } else {
        this.productType = "fibre";
      }
    },
  },
  methods: {
    get: _.get,
    loadRetry() {},
    mapLoadError() {
      console.log('Too many points for gmap, skipping... ');
      this.zoneCoordsString = "";
    },
    productDetails(unPro) {
      return unPro.split(/\r?\n/g);
    },
    setInstallType(installType) {
      this.$store.commit("setInstallType", installType);
    },
    setProduct(pr, promocodeid, productSection) {
      this.chosenProduct = pr;
      this.$store.commit("setProductSection", productSection);
      this.$store.commit("setSelectedProduct", pr.productid);
      this.$store.commit("setPromoCodeId", promocodeid);

      const promocodename = this.promoCodeId;
      
      this.productIds = {
        promocodeproductid: pr.promocodeproductid,
        productid: pr.productid,
        promocodeid,
        promocodename: promocodename,
      };

      this.showModal = true;
    },
    updatePromoCodeProducts(zone) {
      Object.keys(zone.promoCodes).forEach(promoCode => {
        zone.promoCodes[promoCode].products = zone.promoCodes[promoCode].products.map(product => {
          return {
            ...product,
            main_product: [
              {
                ...product.main_product[0],
                promocodeproductid: product.promocodeproductid
              }
            ]
          };
        });
      });
    },
    setBuiltAddress() {
      let tempAddress;
      const baseAddress = this.newAddress || this.fullAddress;

      if (this.productSection && this.productSection.address) {
        tempAddress = this.productSection.address;
      } else if (baseAddress && baseAddress.route) {
        tempAddress = `${baseAddress.street_number || ""} ${
          baseAddress.route || baseAddress.street_name
        }, ${baseAddress.political}, ${baseAddress.locality}, ${baseAddress.administrative_area_level_1},
        ${baseAddress.postal_code}`.trim();
      } else {
        tempAddress = this.address;
      }

      this.$store.commit(
        "setBuiltAddress",
        `${this.unitNumber ? `Unit ${this.unitNumber}, ` : ""}${tempAddress}`
      );
    },
    async submitAddress() {
      // check for existing address / zone
      const address = this.newAddress || this.fullAddress;

      // If unit address type is chosen check unit number format is valid
      if (this.typeOfAddress === "unit") {
        if (!this.unitNumber || !this.unitRegex.test(this.unitNumber.trim())) {
          this.unitNumberError = "Please input only unit number (e.g. \"221B\")";
          return;
        } else {
          this.unitNumberError = "";
        }
      } else {
        this.unitNumber = null;
      }

      this.setBuiltAddress();
      this.$store.commit("setAddressList", this.addresses);
      this.$store.commit("setZone", this.zone);
      let tempPosition = {};
      if (Object.keys(this.coordsFromMap).length) {
        tempPosition = this.coordsFromMap;
      } else {
        tempPosition = this.position;
      }
      this.$store.commit("setPosition", tempPosition);

      this.$router.push({
        name: "purchase",
        params: {
          product: this.chosenProduct,
          address: address,
          addressCode: this.addressCode,
          productIds: this.productIds,
          unitNumber: this.unitNumber,
          buildingName: this.buildingName,
          installType: this.installType,
        },
      });
    },
    adjustHeight() {
      const elFrom = document.querySelector(".modal-card-body");
      // set scroll position in px
      elFrom.scrollLeft = 0;
      elFrom.scrollTop = elFrom.offsetHeight;
    },
  },
};
</script>

<style lang="scss">
@import "~bulma/sass/utilities/mixins";
@import "../styles/variables";

.product-listing {
  input:disabled {
    color: #231f20 !important;
  }

  .search-container {
    p.control {
      display: none;
    }
  }

  padding: 3rem;

  @include until($desktop) {
    padding: 0.5rem;
  }

  .box {
    border-radius: 0;
  }

  .info-link {
    text-decoration: underline;
    color: #000;
  }

  .product-info {
    margin-bottom: 2rem;

    .product-details-top {
      text-align: right;
      padding: 2rem 0;

      @include until($tablet) {
        padding-top: 0;
        font-size: 2rem;
        .additional-text {
          display: none;
        }
        .title {
          font-size: 1.25rem;
        }
      }
    }

    .product-details-perks {
      margin: 2rem;

      svg {
        color: #01a5e8;
        margin-left: -2rem;
        margin-right: 1rem;
      }
    }

    .product-type {
      @include until($desktop) {
        background-color: #f4f4f4;
      }
      @include from($desktop) {
        max-width: 500px;
      }

      .product-type-option {
        display: block;
        cursor: pointer;

        input {
          display: none;

          &:checked + .product-type-label {
            background-color: $secondary-colour;
            font-weight: bold;
            color: #fff;
          }
        }

        .product-type-label {
          display: flex;
          align-content: center;
          padding: 1rem;
          @include from($desktop) {
            font-weight: normal;
          }

          &:hover {
            background-color: lighten($secondary-colour, 80%);
          }
        }

        &::after {
          display: block;
          content: attr(data-name);
          font-weight: bold;
          height: 1px;
          color: transparent;
          overflow: hidden;
          visibility: hidden;
          padding: 0 5rem;
        }
      }
    }

    .product-box {
      padding-bottom: 80px;
      position: relative;
    }

    .product-button-wrap {
      position: absolute;
      bottom: 1.25rem;
      left: 1.25rem;
      right: 1.25rem;
    }

    .product-details-button {
      border-radius: 0;
      padding: 1rem;
      height: auto;
    }

    .product-user-map {
      margin: -1.2rem;
      margin-top: 2rem;
      margin-bottom: -1.65rem;
      width: calc(100% + 2.45rem);
      max-width: unset;
    }
  }

  .modal {
    .modal-card {
      @include until($desktop) {
        min-height: 65vh;
        width: 90vw;
      }
      @include from($desktop) {
        min-height: 50vh;
      }
    }

    .modal-card-head {
      padding-left: 40px;
      text-align: left;
      .modal-card-title {
        width: 80%;
      }
    }
    .modal-card-body {
      padding-left: 40px;
      text-align: left;

      .product-details-button {
        margin-top: 1rem;
        border-radius: 0;
        padding: 1rem;
        height: auto;
      }

      .add-address-button {
        margin-top: 1rem;
      }
    }
  }
}
</style>
